import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { blackUser } from "@/assets";

export function PHistoryTable({ data = [] }) {
  return (
    <>
      <Table className='w-full'>
        <TableHeader>
          <TableRow>
            <TableHead className='w-[100px]'>ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Designations</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Attendance</TableHead>
            <TableHead>Salary Type</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Productivity Hours</TableHead>
            <TableHead className='text-right'>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((person, index) => (
              <TableRow key={person.id || index}>
                <TableCell className='font-medium'>{person.unique_id || person.id || "N/A"}</TableCell>
                <TableCell>
                  <div className='flex items-center gap-2'>
                    <img
                      src={person.avatar || blackUser}
                      alt={person.name}
                      className='w-8 h-8 rounded-full object-cover'
                    />
                    <span>{person.name || "N/A"}</span>
                  </div>
                </TableCell>
                <TableCell>{person.designation || "N/A"}</TableCell>
                <TableCell>{person.phone || "N/A"}</TableCell>
                <TableCell>{person.attendance_days !== undefined ? `${person.attendance_days} Days` : '0 Days'}</TableCell>
                <TableCell className="capitalize">{person.salary_type || "N/A"}</TableCell>
                <TableCell>{person.currency || "GBP"} {person.salary || 0}</TableCell>
                <TableCell>{person.productivity_hours !== undefined ? `${person.productivity_hours} Hours` : '0 Hours'}</TableCell>
                <TableCell className='text-right font-medium'>
                  <span className={`capitalize ${
                    person.payslip_status === 'paid' ? 'text-cgreen' :
                    person.payslip_status === 'unpaid' ? 'text-cred' : 'text-cyellow'
                  }`}>
                    {person.payslip_status || 'Pending'}
                  </span>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9} className="text-center py-8 text-cwhite3">
                No payroll history data found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
}

export default PHistoryTable;
